import Start from "@/stay/views/Start.vue";
import Search from "@/stay/views/Search.vue";
import Booking from "@/stay/views/Booking.vue";


import RoomAvailability from "@/stay/views/RoomAvailability.vue";
import RateSelection from "@/stay/views/RateSelection.vue";
import StayGuests from "@/stay/views/StayGuests.vue";
import StayItinerary from "@/stay/views/StayItinerary.vue";


import StayAddOns from "@/stay/views/StayAddOns.vue";

import StayDetails from "@/stay/views/StayDetails.vue";
import StaySummary from "@/stay/views/StaySummary.vue";
import StayPayment from "@/stay/views/StayPayment.vue";
import StayConfirmation from "@/stay/views/StayConfirmation.vue";

import { createWebHashHistory, createRouter } from "vue-router";

import axios from 'axios';

import { accountStore } from '@/account/store/index';
import { getApiEndpoint } from "../shared/api/utilities";



const StayRoutes = [
    {
        path: "",
        name: "stay_start",
        component: Start
    },
    {
        path: "/stay/search/",
        name: "stay_search",
        component: Search
    },
    {
        path: "/:id/stay/",
        name: "stay_accommodation",
        component: Booking,
        children: [
            {
                path: "room/:leg",
                name: "stay_leg_room_availability",
                component: RoomAvailability,
            },
            {
                path: "rate/:leg",
                name: "stay_leg_room_rates",
                component: RateSelection
            },
            {
                path: "guests",
                name: "stay_guests",
                component: StayGuests
            },
            {
                path: "itinerary",
                name: "stay_itinerary",
                component: StayItinerary
            },
            {
                path: "add-ons",
                name: "stay_addons",
                component: StayAddOns
            },
            {
                path: "details",
                name: "stay_details",
                component: StayDetails
            },
            {
                path: "summary",
                name: "stay_summary",
                component: StaySummary
            },
            {
                path: "payment",
                name: "stay_payment",
                component: StayPayment
            }

        ]
    },
    {
        path: "/:id/stay/confirmation/",
        name: "stay_confirmation",
        component: StayConfirmation
    }
];


const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        ...StayRoutes
    ],
    scrollBehavior(/*to, from, savedPosition*/) {
        return { top: 0 }
    },

});


router.beforeEach((to, from, next) => {
    //the purpose of this is to validate you are a person before we continue to the next page.
    //We only need to check if validated, if we have a token. If we have the token, and the known user is invalid,
    //we then attempt to refresh the token.
    //Otherwise we log the user out, and return to the login page...

    let isAuthenticated = accountStore.getters.isAuthenticated;
    if (isAuthenticated) {


        axios.get(getApiEndpoint() + 'api/session/known-user')
            .then(response => {
                next();
                return;
            })
            .catch(error => {
                next();
                return;
            });
    } else {

        next();
    }
});


export default router;